.onboarding-progress {
    display: block;
    max-width: 360px;
    min-width: 100px;
    margin-top: 6px;
    color: #222;
    text-decoration: none;
    &:hover { color: #8a7000; }
    &:focus-visible { outline: 2px solid #d4ad00; outline-offset: 3px; }
}
.onboarding-progress-label { display: flex; justify-content: space-between; gap: 10px; font-size: 11px; }
.onboarding-progress-track {
    display: block; height: 5px; background: #e8e8e8; border-radius: 3px; margin-top: 3px; overflow: hidden;
    > span { display: block; height: 100%; background: #ffd000; }
}
.onboarding-progress-empty { display: block; margin-top: 6px; font-size: 11px; color: #777; }
